import React, { useState, useEffect } from "react";
import {
  createResource,
  getResource,
  deleteResource,
  createResumeResource,
  getResumeResource,
} from "../../../redux/thunks/Resource";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import PasswordSetUp from "../../PasswordSetUp";
import { getUser } from "../../../redux/thunks/User";
import { useDispatch, useSelector } from "react-redux";
import Radio from "../../../components/sub-component/Radio";
import { isWhiteLabelClient } from "../../../utils/utilities";
import Button from "../../../components/sub-component/Button";
import ProgressBar from "../../../components/common/ProgressBar";
import { getTanentProfile } from "../../../redux/thunks/UserProfile";
import { attachAssessmentResume } from "../../../redux/thunks/Assessment";
import ProcessingIndicator from "../../../components/common/ProcessingIndicator";
import { ReactComponent as CrossIcon } from "../../../assets/icons/candidate-assessment/x.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/candidate-assessment/trash.svg";
import { ReactComponent as UploadIcon } from "../../../assets/icons/candidate-assessment/upload.svg";
import { ReactComponent as AttachIcon } from "../../../assets/icons/candidate-assessment/attach.svg";
import { ReactComponent as TestFuseWatermarkIcon } from "../../../assets/icons/candidate-assessment/Watermark.svg";

function ResumeUpload({ assessment }) {
  const params = useParams();
  const dispatch = useDispatch();

  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedResume, setSelectedResume] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [downloadingResumeId, setDownloadingResumeId] = useState(null);

  const access_token = useSelector(
    (state) => state.authReducer?.data?.access_token,
  );
  const auth = useSelector((state) => state.authReducer);
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const resource = useSelector((state) => state.resourceReducer);

  const handleFileUpload = async (event) => {
    if (event.target.files[0].size / 1024 / 1024 > 100) {
      setError("The uploaded file exceeded the max size limit (i.e 100mb)");
      return;
    }
    setError("");

    const formData = new FormData();
    formData.append("file", event.target.files[0], event.target.files[0].name);
    setSelectedFileName(event.target.files[0].name);
    setSelectedFile(event.target.files[0]);
    await dispatch(createResumeResource({ data: formData, signal: null }));
    setIsFilePicked(true);
    await dispatch(getResumeResource());
  };

  const handleCancelUpload = async () => {
    await dispatch(deleteResource({ id: resource?.resume_data?.id }));
    setSelectedFileName(null);
    setSelectedFile(null);
    setIsFilePicked(false);
    await dispatch(getResumeResource({ access_token: access_token }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async () => {
    setProcessing(true);
    await dispatch(
      attachAssessmentResume({
        data: {
          assess_id: params.id,
          resume_id: selectedResume
            ? selectedResume?.id
            : resource?.resume_data?.id,
        },
      }),
    );
    setProcessing(false);
  };

  useEffect(() => {
    dispatch(getResumeResource({ access_token: access_token }));
  }, []);

  return (
    <div className="candidate-assessment-flow-container">
      <div
        className="candidate-assment-flow-wrapper"
        style={{ height: "80vh" }}
      >
        <div
          className="d-flex flex-column align-items-center"
          style={{
            minWidth: isOnMobileScreen ? "100%" : "750px",
            padding: "24px",
            gap: "24px",
            borderRadius: "24px",
            backgroundColor: "white",
          }}
        >
          <span className={`headline-4 dark-100 text-center`}>
            Upload Resume
          </span>
          {!resource?.resume_upload_percentage > 0 && (
            <div
              className="d-flex flex-column align-items-center"
              style={{ gap: "24px" }}
            >
              <span className="body-2">
                Please upload your latest resume or choose from one of the
                existing ones.
              </span>
            </div>
          )}
          {resource?.loading || loading ? (
            <div style={{ height: "20px", width: "20px" }}>
              <ProcessingIndicator />
            </div>
          ) : (
            <>
              {resource?.resumes && (
                <div
                  className="w-100 d-flex flex-column align-items-start"
                  style={{ gap: "8px", paddingRight: "24px" }}
                >
                  {resource?.resumes?.map((resume, i) => {
                    return (
                      <div
                        key={i}
                        className="w-100 d-flex flex-row align-items-center justify-content-between"
                        style={{ gap: "24px" }}
                      >
                        <Radio
                          varrient="radio-with-input-without-background"
                          readonly
                          placeholder=""
                          dangerouslySetInnerHTML
                          onChangeRadioOption={() => {
                            setSelectedResume(resume);
                            setIsFilePicked(true);
                          }}
                          checked={resume.id === selectedResume?.id}
                          value={resume.name}
                        />
                        <span
                          className="body-3 primary-text underline pointer"
                          onClick={async (e) => {
                            e.preventDefault();
                            setDownloadingResumeId(resume.id);

                            const link = document.createElement("a");
                            link.href = resume.resume_pdf;
                            link.download = `resume-${resume.id}.pdf`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            setTimeout(
                              () => setDownloadingResumeId(null),
                              3200,
                            );
                          }}
                        >
                          Download
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
              <>
                {resource?.resume_upload_percentage > 0 ? (
                  <div className="uploaded-doc-container">
                    <AttachIcon />
                    <div
                      className="d-flex flex-column align-items-start"
                      style={{ width: "calc(100% - 36px)", gap: "8px" }}
                    >
                      <div className="w-100 d-flex flex-row align-items-center justify-content-between">
                        <div className="w-100 d-flex flex-column align-items-start">
                          <span className="body-2 dark-100">
                            {resource.processing_resume
                              ? selectedFileName
                              : resource?.resume_data?.name}
                          </span>
                          <span className="body-2 dark-100">
                            {resource.processing_resume
                              ? (selectedFile?.size / 1024).toFixed(1)
                              : (resource?.resume_data?.size / 1024).toFixed(
                                  1,
                                )}{" "}
                            kb
                          </span>
                        </div>
                        {resource.processing_delete ? (
                          <ProcessingIndicator className="medium-indicator" />
                        ) : resource?.resume_upload_percentage < 100 ? (
                          <></>
                        ) : (
                          <DeleteIcon
                            cursor="pointer"
                            onClick={handleCancelUpload}
                          />
                        )}
                      </div>
                      <ProgressBar
                        varrient={"progress-with-upload-doc"}
                        value={resource?.resume_upload_percentage}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="text-upload-doc-container">
                      <div
                        className="d-flex flex-column align-items-center pointer"
                        style={{
                          position: "relative",
                          minWidth: "260px",
                          height: "90px",
                          gap: "12px",
                        }}
                      >
                        <div
                          className="d-flex flex-column align-items-center"
                          style={{ width: "30px", height: "30px" }}
                        >
                          <UploadIcon />
                        </div>
                        <span className="subtitle-2 dark-100">
                          Drag & drop your resume here or click to upload.
                        </span>
                        <span className="body-2 dark-50">
                          pdf, csv, txt, or doc (max size 100mb)
                        </span>
                        <input
                          className="pointer"
                          style={{
                            position: "absolute",
                            left: 0,
                            right: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                          }}
                          type="file"
                          disabled={resource.processing_resume}
                          accept=".pdf, .csv, .txt, .doc, .docx"
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                    {error && (
                      <div className="uploaded-doc-container align-items-center">
                        <AttachIcon />
                        <span className="body-2 danger-text">{error}</span>
                      </div>
                    )}
                  </>
                )}
              </>
            </>
          )}
          <div className="login-input-group d-flex align-items-right justify-content-right">
            <Button
              btn="ragular-btn"
              varrient="primary"
              title={"Next"}
              processing={processing}
              disabled={!isFilePicked}
              onClick={handleSubmit}
              style={{ height: "52px", width: "90px" }}
            />
          </div>
        </div>
      </div>
      <div className="watermark">
        {isWhiteLabelClient() ? (
          <></>
        ) : (
          <TestFuseWatermarkIcon style={{ height: "50px" }} />
        )}
      </div>
    </div>
  );
}

export default ResumeUpload;
